import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import "../../assets/css/addEuipment.css";

import logoutIcon from "../../assets/icons/logout-1.svg";
import close from "../../assets/icons/close.svg";
import recyclebin from "../../assets/icons/recycle-bin2.svg";
import { useDispatch } from "react-redux";
import Loader from "../../Components/LoaderAndSpinner/Loader";
import { removeToken } from "../../AuthMiddleware/TokenService";
import { clearUser } from "../../Redux/User/UserSlice";
import { clearToken } from "../../Redux/Auth/TokenSlice";
import fetchWrapper from "../../AuthMiddleware/FetchWrapper";

const ProfileSetting = () => {
	const dispatch = useDispatch();
	const [formData, setFormData] = useState({
		avatar: "",
		userId: "",
		name: "",
		email: "",
		mobile: "",
		roleId: "",
		departmentId: "",
		currentPassword: "",
		newPassword: "",
		confirmPassword: "",
	});
	const [roles, setRoles] = useState([]);

	const [displayName, setDisplayName] = useState(""); // New state for displayed name
	// const [successMessage, setSuccessMessage] = useState("");
	const [errorMessage, setErrorMessage] = useState("");
	const [logoutModal, setLogoutModal] = useState(false);
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();
	const [avatarFile, setAvatarFile] = useState(null);
	const [errors, setErrors] = useState({});
	const [avatarChange, setAvatarChange] = useState("");

	// Fetch the initial profile data when the component mounts

	const handleFileChange = (e) => {
		setAvatarFile(e.target.files[0]);
		setAvatarChange(e.target.files[0]?.name || "");
	};

	const fetchUserData = async () => {
		const authToken = sessionStorage.getItem("jwt_token");


		if (!authToken) {
			setErrorMessage("No auth token found in session storage");
			setLoading(false);
			return;
		}

		try {
			const response = await fetch(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/me`,
				{
					method: "POST",
					headers: {
						Authorization: `Bearer ${authToken}`,
					},
				}
			);

			if (response.ok) {
				const data = await response.json();


				setFormData({
					userId: data.user.id,
					name: data.user.name,
					email: data.user.email,
					mobile: data.user.mobile_no,
					roleId: data.user.role_id,
					departmentId: data.user.department_id,
					avatar: data.user.avatar,
				});

				setDisplayName(data.user.name);
				setLoading(false);
			} else {
				const errorData = await response.json();


				const errorMessaged = errorData.message;

				setErrors(errorData.errors || {});
				toast.error(errorMessaged);
				setLoading(false);
				setErrorMessage("Failed to Load User Profile Data");
				toast.error("Failed to Load User Profile Data");
			}
		} catch (err) {
			setErrorMessage(err.message);
			setLoading(false);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchUserData();
	}, [avatarChange]);

	useEffect(() => {
		const token = sessionStorage.getItem("jwt_token");
		const fetchRoles = () => {
			fetch(`${process.env.REACT_APP_BASE_API_URL1}/api/v1/role/getall`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error("Error fetching roles");
					}
					return response.json();
				})
				.then((data) => {


					setRoles(data.roles);

					// if (Array.isArray(data.roles)) {
					//   setRoles(data.roles);


					// } else {
					//   throw new Error("Roles data is not an array");
					// }
				})
				.catch((error) => {
					console.error(error);
					setRoles([]);
				});
		};
		fetchRoles();
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		const form = new FormData();
		// form.append("userId", formData.userId);
		form.append("name", formData.name);
		form.append("email", formData.email);
		form.append("mobile_no", formData.mobile);
		if (avatarFile) {
			form.append("avatar", avatarFile);
		}

		try {
			const response = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/profile`,
				{
					method: "POST",
					body: form, // Use the FormData object as the body
				},
				navigate,
				true // Pass true to receive the raw response
			);

			if (response.ok) {
				const data = await response.json();

				// setSuccessMessage("Profile updated successfully");
				toast.success("Profile updated successfully");
				setAvatarChange(avatarFile?.name || formData.avatar);
			} else {
				const errorData = await response.json();
				setErrorMessage(errorData.message || "Failed to update profile");
				toast.error(errorData.message || "Failed to update profile");

				alert("Error:", errorData);
			}
		} catch (error) {
			console.error("Error updating profile:", error);
			setErrorMessage("Failed to update profile");
			toast.error("Failed to update profile");
		} finally {
			setLoading(false);
			fetchUserData();
		}
	};
	const handleChangePassword = async (e) => {
		e.preventDefault();
		try {


			const response = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/password`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						email: formData.email,
						currentPassword: formData.currentPassword,
						newPassword: formData.newPassword,
						confirmPassword: formData.confirmPassword,
					}),
				}
			);



			// setSuccessMessage(response.message || "Password changed successfully");
			toast.success("Password changed successfully");
			setErrorMessage("");
		} catch (error) {
			console.error("Error changing password:", error);
			const errorMessages =
				error.response.errors ||
				error.response.message ||
				"Failed to change password";
			toast.error("Failed to change password");
			setErrorMessage(errorMessages);
			// setSuccessMessage("");
		}
	};

	// const logoutAction = () => {
	//   removeToken();
	//   sessionStorage.removeItem("jwt_token");
	//   sessionStorage.removeItem("email");
	//   sessionStorage.removeItem("username");
	//   sessionStorage.removeItem("user");
	//   dispatch(clearUser()); // Clear user state in Redux
	//   dispatch(clearToken()); // Clear token state in Redux
	//   navigate("/auth/login"); // Navigate to login page after logout
	// };
	const logoutAction = async () => {
		// Retrieve the token from sessionStorage
		const token = sessionStorage.getItem("jwt_token");

		removeToken();
		sessionStorage.removeItem("jwt_token");
		sessionStorage.removeItem("email");
		sessionStorage.removeItem("username");
		sessionStorage.removeItem("user");
		dispatch(clearUser()); // Clear user state in Redux
		dispatch(clearToken());

		try {
			const response = await fetch(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/logout`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${token}`, // Include the token in the headers
					},
				}
			);

			if (response.ok) {

			} else {
				console.error("Failed to log out user");
			}
		} catch (error) {
			console.error("Failed to fetch template menu items", error);
		}

		// Clear token state in Redux
		navigate("/auth/login"); // Navigate to login page after logout
	};

	return (
		<>
			{loading ? <Loader /> : ""}
			<div className="container">
				<h5 className="pt-3 pb-4 m-0">Profile Settings</h5>
				<div className="profileSetting-name pt-3 py-2 px-5 mb-3 d-flex justify-content-between align-content-center">
					<div className="d-flex gap-3">
						<img
							className="profileSetting-pic"
							src={`${process.env.REACT_APP_BASE_API_URL1}/${formData.avatar}`}
							//src={`http://192.168.0.189:8080/${formData.avatar}`} // Adjust URL structure based on your backend
							alt="ProfileImage"
						/>
						<div>
							<h5 className="m-0">{displayName}</h5>
							<p className="small-body m-0">
								{roles.length > 0 ? (
									<p>
										{roles.find((role) => role._id === formData.roleId)
											?.role_name || "N/A"}
									</p>
								) : (
									<p>Loading...</p>
								)}
							</p>
						</div>
					</div>
					<div className="logout">
						<span onClick={() => setLogoutModal(true)}>
							<img src={logoutIcon} alt="Logout" />
						</span>
					</div>
				</div>

				{/* Profile Update Section */}
				<div className="addEuipment">
					<div className="addEuipment-header">
						<h4>Update Profile</h4>
					</div>
					<form onSubmit={handleSubmit}>
						<div className="addEuipment-form">
							<div className="row">
								<div className="col d-flex flex-column addEuipment-form-col">
									<label htmlFor="name" className="addEuipment-form-text">
										Full Name
									</label>
									<input
										name="name"
										className={`signin-form-input  ${errors.name ? "is-invalid" : ""
											}`}
										id="name"
										placeholder="Full name"
										value={formData.name}
										onChange={handleChange}
									/>
									{errors.name && (
										<div className="invalid-feedback">{errors.name}</div>
									)}
								</div>

								<div className="col d-flex flex-column addEuipment-form-col">
									<label htmlFor="email" className="addEuipment-form-text">
										Email
									</label>
									<input
										name="email"
										id="email"
										placeholder="Email"
										value={formData.email}
										onChange={handleChange}
										disabled
									/>
								</div>
							</div>

							<div className="row">
								<div className="col d-flex flex-column addEuipment-form-col">
									<label htmlFor="mobile" className="addEuipment-form-text">
										Phone Number
									</label>
									<input
										name="mobile"
										id="mobile"
										placeholder="Phone Number"
										value={formData.mobile}
										className={`signin-form-input  ${errors.mobile_no ? "is-invalid" : ""
											}`}
										onChange={handleChange}
									/>

									{true && <div className="invalid-feedback">dddd</div>}
								</div>
								<div className="col d-flex flex-column addEuipment-form-col">
									<label htmlFor="profilePic" className="addEuipment-form-text">
										Profile Picture
									</label>
									<input
										name="profilePic"
										id="profilePic"
										type="file"
										accept="image/*"
										onChange={handleFileChange}
									/>
								</div>
							</div>

							<div className="addEuipment-form-submit">
								<button
									className="button-darkBlue"
									type="submit"
									class="btn-bg"
									style={{ width: "300px" }}
								>
									Save Changes
								</button>
							</div>
						</div>
					</form>
				</div>
				<br></br>

				{/* Password Change Section */}
				<div className="addEuipment">
					<div className="addEuipment-header">
						<h4>Change Password</h4>
					</div>
					<form onSubmit={handleChangePassword}>
						<div className="addEuipment-form">
							<div className="row mb-4">
								<small className="text-center">Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special character</small>
							</div>
							<div className="row">
								<div className="col d-flex flex-column addEuipment-form-col">
									<label
										htmlFor="currentPassword"
										className="addEuipment-form-text"
									>
										Current Password
									</label>
									<input
										name="currentPassword"
										id="currentPassword"
										type="password"
										placeholder="Current Password"
										value={formData.currentPassword}
										onChange={handleChange}
									/>
									{errorMessage && (
										<div className="mt-2" style={{ color: "#dc3545" }}>
											{errorMessage.currentPassword}
										</div>
									)}
								</div>

								<div className="col d-flex flex-column addEuipment-form-col">
									<label
										htmlFor="newPassword"
										className="addEuipment-form-text"
									>
										New Password
									</label>
									<input
										name="newPassword"
										id="newPassword"
										type="password"
										placeholder="New Password"
										value={formData.newPassword}
										onChange={handleChange}
									/>
									{/* {errors.department_id && (
                          <div className="invalid-feedback">
                            {errors.department_id}
                          </div>
                        )} */}
									{errorMessage.newPassword && (
										<div className="mt-2" style={{ color: "#dc3545" }}>
											{errorMessage.newPassword}
										</div>
									)}
								</div>

								<div className="col d-flex flex-column addEuipment-form-col">
									<label
										htmlFor="confirmPassword"
										className="addEuipment-form-text"
									>
										Confirm Password
									</label>
									<input
										name="confirmPassword"
										id="confirmPassword"
										type="password"
										placeholder="Confirm Password"
										value={formData.confirmPassword}
										onChange={handleChange}
									/>
									{errorMessage && (
										<div className="mt-2" style={{ color: "#dc3545" }}>
											{errorMessage.confirmPassword}
										</div>
									)}
								</div>
								{errorMessage && (
									<div
										className="mb-2 "
										style={{ color: "#dc3545", marginTop: "-10px" }}
									>
										{errorMessage.passwordMatch}
									</div>
								)}
							</div>

							<div className="addEuipment-form-submit">
								<button
									className="button-darkBlue"
									type="submit"
									class="btn-bg"
									style={{ width: "300px" }}
								>
									Change Password
								</button>
							</div>
						</div>
					</form>
				</div >
			</div >
			<div
				id="overlay"
				className={`modal fade ${logoutModal ? "show" : ""}`}
				tabIndex="-1"
				role="dialog"
				style={{
					zIndex: 30,
					display: logoutModal ? "block" : "none",
					transition: "width 2s",
				}}
			>
				<div>
					<div className="addunit-card Width 25%">
						<div className="addunit-header">
							<h4></h4>
							<button
								style={{ border: "none", backgroundColor: "inherit" }}
								type="button"
								className="close"
								onClick={() => setLogoutModal(false)}
							>
								<img src={close} width="28px" height="28px" alt="Close" />
							</button>
						</div>

						<div className="delete-unit">
							<img
								src={recyclebin}
								width="48px"
								height="48px"
								alt="Recyclebin"
							/>
							<h4 className="delete-unit-h4">Logout</h4>
							<p className="delete-unit-text">
								Are you sure you want to Logout?
							</p>
						</div>

						<div className="addunit-card-footer justify-content-between">
							<button
								type="button"
								className="discard-btn"
								onClick={() => setLogoutModal(false)}
							>
								CANCEL
							</button>
							<button
								type="button"
								className="update-btn"
								onClick={logoutAction}
							>
								CONFIRM
							</button>
						</div>
					</div>
				</div>
			</div>

			{/* Logout Modal */}
			{/* {logoutModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Logout</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setLogoutModal(false)}
                >
                  <img src={close} alt="Close" />
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to logout?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setLogoutModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={logoutAction}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}

			{/* Success and Error Messages */}
			<ToastContainer
				position="top-right"
				autoClose={3000}
				hideProgressBar={false}
			/>
		</>
	);
};

export default ProfileSetting;
